export default __webpack_public_path__ + "static/media/logo_3dmeet_full.d823e9ff.png";